import React from 'react';
import { Flex, Group } from '@mantine/core';
import Select from '../inputs/Select';
import { LevelField } from './level-field';
import { UseFormReturnType } from '@mantine/form';
import { DealPricingGrid } from 'app/models/deal-params';
import { pricingGridTypeOptions, pricingGridMarginOrFeeTypeOptions } from 'app/models/dropdown-options';
import IonIcon from '@reacticons/ionicons';

interface PricingGridEntryProps {
    index: number;
    form: UseFormReturnType<{ pricingGrid: DealPricingGrid[] }>;
    selectedOptions: string[];
}

export const PricingGridEntry: React.FC<PricingGridEntryProps> = ({ index, form, selectedOptions }) => {
    // Functions to handle adding a new level and removing the entire grid entry
    const handleAddLevel = () => {
        const newLevels = [...form.values.pricingGrid[index].levels, ''];
        form.setFieldValue(`pricingGrid.${index}.levels`, newLevels);
    };

    const handleRemoveGrid = () => {
        form.removeListItem('pricingGrid', index);
    };

    // Updated options with disabled already selected ones
    const updatedPricingGridTypeOptions = pricingGridTypeOptions.map(option => ({
        ...option,
        disabled: selectedOptions.includes(option.value) && option.value !== form.values.pricingGrid[index].pricingGridType,
    }));

    return (
        <Group w='100' grow>
            <Flex direction={'column'}>
                <Group w='100' grow style={{ paddingBottom: '10px', height: 'auto' }}>
                    <Select
                        label="Pricing Grid Type"
                        {...form.getInputProps(`pricingGrid.${index}.pricingGridType`)}
                        data={updatedPricingGridTypeOptions}
                    />
                    <Select
                        label="Margin and/or Fee"
                        {...form.getInputProps(`pricingGrid.${index}.marginOrFee`)}
                        data={pricingGridMarginOrFeeTypeOptions}
                    />
                </Group>
                {form.values.pricingGrid[index].levels.map((level, cpIndex) => (
                    <LevelField
                        key={cpIndex}
                        cpIndex={cpIndex}
                        levelValue={level}
                        handleLevelChange={(newValue) => {
                            const updatedLevels = [...form.values.pricingGrid[index].levels];
                            updatedLevels[cpIndex] = newValue ?? '';
                            form.setFieldValue(`pricingGrid.${index}.levels`, updatedLevels);
                        }}
                        handleRemoveLevel={() => {
                            const updatedLevels = form.values.pricingGrid[index].levels.filter((_, i) => i !== cpIndex);
                            form.setFieldValue(`pricingGrid.${index}.levels`, updatedLevels);
                        }}
                    />
                ))}
                <Group w='100' grow style={{ paddingBottom: '3px', height: 'auto' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <IonIcon name="add-circle-outline" className="click-ion-icon" onClick={handleAddLevel} />
                        <span
                            style={{
                                marginLeft: '8px',
                                fontFamily: 'Plus Jakarta Sans',
                                fontWeight: 'bold',
                                fontSize: '1em',
                            }}
                        >
                            Add Level
                        </span>
                    </div>
                </Group>
                <Group w='100%' grow style={{ marginTop: '-3px' }}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <IonIcon name='trash-outline' className="click-ion-icon" style={{ color: "red", width: '20px', height: '20px' }} onClick={handleRemoveGrid} />
                        <span
                            style={{
                                fontFamily: 'Plus Jakarta Sans',
                                color: '#111928',
                                fontSize: '12px',
                                fontWeight: 'bold',
                            }}
                        >
                            Remove pricing grid
                        </span>
                    </div>
                </Group>
            </Flex>
        </Group>
    );
};